// extracted by mini-css-extract-plugin
export default {"auction":"AuctionWidget_auction__ALk5A","header":"AuctionWidget_header__wLBPw","wheel":"AuctionWidget_wheel__uuwXM","segment":"AuctionWidget_segment__Ier+l"};